export default "__VITE_ASSET__B7qoriN8__"